// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-237256a6]  {\n  font-weight: bolder !important;\n}\nbutton.btn--disabled[data-v-237256a6] {\n  background-color: rgba(100, 100, 100, 0.5) !important;\n}\n.role-permissions__title-info[data-v-237256a6] {\n  font-size: 12px;\n  color: var(--gray-200);\n  padding-left: 30px;\n  padding-right: 60px;\n  margin-top: 8px;\n}\n.role-permissions__title[data-v-237256a6] {\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
